import React, { useState } from 'react'
import Cookies from 'js-cookie';

import { updateAdminApi } from '../../api/usersApi'

import dummyFounder from '../../assets/images/dummyFounder.png'


const Password = ({ setNotificationMessage, setShowNotification }) => {

    const existingCookie = Cookies.get('userData');
    let userData = existingCookie ? JSON.parse(existingCookie) : {};

    const [currentPassword, setCurrentPassword] = useState('')
    const [password, setPassword] = useState('')
    const [reTypePassword, setReTypePassword] = useState('')
    const [isSaveLoading, setIsSaveLoading] = useState(false);
    const [errorMessage, setErrorMessage] = useState({
        currentPassword: '',
        password: '',
        reTypePassword: '',
        comparePassword: '',
    });

    const updateData = async () => {
        setIsSaveLoading(false)
        setShowNotification(false);
        let success = false;
        try {
            setIsSaveLoading(true)
            success = await updateAdminApi({
                adminId: userData?.adminId,
                data: {
                    currentPassword: currentPassword,
                    password: password
                }
            });
            if (success) {
                setShowNotification(true);
                setNotificationMessage('Your password have been successfully saved.');
                setTimeout(() => {
                    setShowNotification(false);
                }, 8000);
                setIsSaveLoading(false);
                setCurrentPassword('');
                setPassword('');
                setReTypePassword('');
                return true;
            } else {
                setIsSaveLoading(false);
            }
            return true;
        } catch (error) {
            console.log(error);
            const errMsg = error?.response?.data?.message;
            if (errMsg?.toLowerCase().includes("current password is incorrect")) {
                setErrorMessage((prev) => ({
                    ...prev,
                    currentPassword: errMsg,
                }));
            }
            setIsSaveLoading(false)
            return false;
        }
    }

    const handleSave = async () => {
        let isValid = true;

        const newErrors = {
            currentPassword: '',
            password: '',
            reTypePassword: '',
            comparePassword: '',
        };
        if (!currentPassword?.trim()) {
            newErrors.currentPassword = 'Please fill current password.';
            isValid = false;
        }
        if (!password?.trim()) {
            newErrors.password = 'Please fill password.';
            isValid = false;
        }
        if (!reTypePassword?.trim()) {
            newErrors.reTypePassword = 'Please fill confirm password.';
            isValid = false;
        }
        if (password?.trim() && reTypePassword?.trim() && password?.trim() !== reTypePassword?.trim()) {
            newErrors.comparePassword = 'Password and confirm password must be same.';
            isValid = false;
        }
        setErrorMessage(newErrors);
        if (!isValid) return;
        setIsSaveLoading(true);
        if (currentPassword?.trim() === password?.trim()) {
            setTimeout(() => {
                setIsSaveLoading(false);
                setCurrentPassword('');
                setPassword('');
                setReTypePassword('');
            }, 500);
            return;
        }
        await updateData();
    };

    return (
        <div className='password-section'>
            <div className="field-block">
                <div className="label">Current password</div>
                <div className='password-field'>
                    <div className="password-input-group">
                        <div className={`input-group ${currentPassword ? 'filled' : ''} ${errorMessage?.currentPassword ? 'show-error update-input-group' : ''}`}>
                            <input type="password" id='currentPassword' className='' name='currentPassword' autoComplete="off" value={currentPassword} onChange={(e) => {
                                setCurrentPassword(e.target.value)
                                if (errorMessage?.currentPassword) {
                                    setErrorMessage(prev => ({ ...prev, currentPassword: '' }));
                                }
                            }} />
                            <label className="update-input-label" htmlFor="password">Current password</label>
                            {errorMessage?.currentPassword && (
                                <p className="error-message update-input-error">{errorMessage?.currentPassword}</p>
                            )}
                        </div>
                    </div>
                </div>
            </div>
            <div className="field-block">
                <div className="label">New password</div>
                <div className='password-field'>
                    <div className="password-input-group">
                        <div className={`input-group ${password ? 'filled' : ''} ${errorMessage?.password ? 'show-error update-input-group' : ''}`}>
                            <input type="password" id="password" name="password" autoComplete="off" value={password}
                                onChange={(e) => {
                                    setPassword(e.target.value);
                                    if (errorMessage.password || errorMessage?.comparePassword) {
                                        setErrorMessage(prev => ({ ...prev, password: '', comparePassword: '' }));
                                    }
                                }}
                            />
                            <label className="update-input-label" htmlFor="password">New password</label>
                            {errorMessage?.password && (
                                <p className="error-message update-input-error">{errorMessage?.password}</p>
                            )}
                        </div>
                        <div className={`input-group ${reTypePassword ? 'filled' : ''} ${errorMessage?.reTypePassword ? 'show-error update-input-group' : ''}`}>
                            <input type="password" id="reTypePassword" name="reTypePassword" autoComplete="off" value={reTypePassword}
                                onChange={(e) => {
                                    setReTypePassword(e.target.value);
                                    if (errorMessage?.reTypePassword || errorMessage?.comparePassword) {
                                        setErrorMessage(prev => ({ ...prev, reTypePassword: '', comparePassword: '' }));
                                    }
                                }}
                            />
                            <label className="update-input-label" htmlFor="reTypePassword">Re-type new password</label>
                            {errorMessage?.reTypePassword && (
                                <p className="error-message update-input-error">{errorMessage?.reTypePassword}</p>
                            )}

                        </div>
                    </div>
                    {errorMessage?.comparePassword && (
                        <p className="error-message update-input-error">{errorMessage?.comparePassword}</p>
                    )}
                </div>
            </div>
            <div className='save-button-group'>
                <div className='cancel-button'>Cancel</div>
                <button
                    className={`save-button button ${isSaveLoading ? 'btn_loading' : ''
                        }`}
                    onClick={() => { handleSave(); }}
                >
                    {isSaveLoading ? (
                        <div className="registerLoader">
                            <div className="ring-loader"></div>
                        </div>
                    ) : (
                        'Save'
                    )}
                </button>
            </div>
        </div>
    )
}

export default Password